export interface DistributorResponse {
  city: string;
  contact_email: string;
  contact_first_name: string;
  contact_last_name: string;
  contact_name: string;
  contact_phone: string;
  contact_title: string;
  country: string;
  distributor_id: number;
  email: string;
  name: string;
  phone: string;
  postal_code: string;
  state: string;
  street_address: string;
}

/**
 * Fetches distributor information based on a specific SKU.
 *
 * Sends a GET request to the `/index.php/rest/V1/distributors/get-by-sku/{sku}` endpoint.
 *
 * @param sku An optional string representing the product SKU.
 * @returns A promise that resolves to an array of distributor data for the specified SKU.
 * @throws An error if the fetch request fails or the response is not OK.
 */
export const fetchDistributors = async (
  sku?: string,
): Promise<DistributorResponse[]> => {
  try {
    if (sku) {
      const response = await fetch(
        `/index.php/rest/V1/distributors/get-by-sku/${sku}`,
        {
          method: 'GET',
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      return data;
    }
    return [];
  } catch (error) {
    console.error('Error fetching distributors:', error);
    throw error;
  }
};
